import { Outlet } from 'react-router-dom';

import React from 'react';
import { Header } from '../organisms/Header';
import styled from 'styled-components';

export const MainLayout = () => {
  return (
      <Root>
          <Header/>
          <BodyContainer>
            <Outlet/>
          </BodyContainer>
      </Root>
  );
};


const Root = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    max-width: 1440px;
    min-height: 100vh;
    overflow: hidden;
    position: relative;
    width: 100%;
    background-color: white;
`;
const BodyContainer = styled.div`
    padding: 80px;

`;
